module.exports = __webpack_public_path__ + "static/img/promoted_icon_inner.579e0f96.png";